import angular from 'angular';
import myLoansContextMenuComponent from './myLoansContextMenu.component';

let myLoansContextMenuModule = angular.module('myLoansContextMenu', [
])

.component('myLoansContextMenu', myLoansContextMenuComponent)

.name;

export default myLoansContextMenuModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansContextMenu/myLoansContextMenu.js